/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../client.ts';
import type {
  TelegramProductsModeratorControllerFindProductToModerateByIdQueryResponse,
  TelegramProductsModeratorControllerFindProductToModerateByIdPathParams,
  TelegramProductsModeratorControllerFindProductToModerateById401,
  TelegramProductsModeratorControllerFindProductToModerateById404,
} from '../types/TelegramProductsModeratorControllerFindProductToModerateById.ts';

function getTelegramProductsModeratorFindProductToModerateByIdUrl(
  id: TelegramProductsModeratorControllerFindProductToModerateByIdPathParams['id'],
) {
  const res = { method: 'GET', url: `/api/moderator/telegram/products/${id}` as const };
  return res;
}

/**
 * {@link /api/moderator/telegram/products/:id}
 */
export async function telegramProductsModeratorFindProductToModerateById(
  id: TelegramProductsModeratorControllerFindProductToModerateByIdPathParams['id'],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    TelegramProductsModeratorControllerFindProductToModerateByIdQueryResponse,
    ResponseErrorConfig<
      | TelegramProductsModeratorControllerFindProductToModerateById401
      | TelegramProductsModeratorControllerFindProductToModerateById404
    >,
    unknown
  >({
    method: 'GET',
    url: getTelegramProductsModeratorFindProductToModerateByIdUrl(id).url.toString(),
    ...requestConfig,
  });
  return res.data;
}
